const VERSION_PLACEHOLDER = "VERSION";

// Review builds never replace the placeholder; they get no release.
export function sentryRelease(version: string): string | undefined {
  return version === VERSION_PLACEHOLDER || version === ""
    ? undefined
    : version;
}
